import React from 'react';
import { Input, Select } from 'formsy-react-components';
import { stateOptions } from '../../utils';

export const Location = React.createClass({
  render() {
    const { profile } = this.props;
    return (
      <div className="form-panel location">
        <div className="heading">Location</div>
        <hr />
        <Input
          label="Street Address"
          type="text"
          name="street_1"
          value={profile.get('street_1') || ''}
          placeholder="Enter your street address"
          labelClassName="small-12"
          elementWrapperClassName="small-12"
        />
        <Input
          label="Street Address (continued)"
          type="text"
          name="street_2"
          value={profile.get('street_2') || ''}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          placeholder="Street address continued"
        />
        <Input
          label="City"
          type="text"
          name="city"
          value={profile.get('city') || ''}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          placeholder="Enter your city"
        />
        <Select
          label="State"
          name="state"
          options={stateOptions}
          value={profile.get('state') || ''}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          required
        />
        <Input
          label="ZIP"
          type="number"
          name="zipcode"
          value={profile.get('zipcode') || ''}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          placeholder="Enter your ZIP"
        />
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/profile/location.jsx
 **/